export default __webpack_public_path__ + "static/media/page-not-found.aad0ae12.png";